import { MaterialTicketType } from '../enums'
import { Services } from '../services'

export class MaterialTicket {
    id!: string
    materialType!: MaterialTicketType
    concreteType!: string
    job!: string
    date!: Date
    truck!: string
    trailer1!: string
    trailer2!: string
    vendor!: string
    lot!: string | undefined
    material!: string | undefined
    quantity!: number | undefined
    units!: string
    pumpTruckVendor!: number
    testingVendor!: number
    ticket!: string | undefined
    pumpTruckTicket!: string | undefined
    testingTicket!: string | undefined
    invoiceNumber!: string
    invoiceDate!: Date
    price!: number
    userId!: string
    createdOn!: Date
    notes!: string

    imageUrls!: string[]

    isInvoiced!: boolean
    extendedPrice!: number
    materialName!: string
    pitName!: string

    protected $setProperties(source: any, services: Services): void {
        if (source.invoiceNumber) source.isInvoiced = true
        else source.isInvoiced = false

        if (source.price && source.quantity) source.extendedPrice = source.price * source.quantity

        let materialName = ''
        if (source.material && services.data.materials) {
            const match = services.data.materials.items.filter(x => x.material == source.material)
            if (match.length > 0) {
                materialName = match[0].description
            }
        }
        source.materialName = materialName

        let pitName = ''
        if (source.lot && source.vendor && services.data.materialPits) {
            const match = services.data.materialPits.items.filter(x => x.vendor === source.vendor && x.addressSeq === source.lot)
            if (match.length > 0) {
                pitName = match[0].description
            }
        }
        source.pitName = pitName
    }
}
